import meta from '../../data/meta.json';

export const apiBaseUrl = meta.apiUrl;

export const apiEndpoints = {
    GET_TOKEN: '/get/token',
    AUTHORIZE: 'authorize',
    LOGIN: '/user/login',
    REGISTER: '/user/register',
    LOGOUT: '/user/logout',
    FETCH_LEVEL_CONFIG: '/game/start',
    GET_USER_DATA: '/user/get',
    RESET_PASSWORD: '/user/reset/password',
    SET_NEW_PASSWORD: '/user/confirm/new-password',
    UPLOAD_RESULT: '/game/end',
    GET_LEADERBOARD: '/game/get/leaderboard',
    GET_IS_USER_LOGGED: '/user/is-logged',
    GET_GAME_SESSION_DATA: '/game/get'
};
